import React from "react";
import './App.css';
 
import Service from './Component/Service';
import About from './Component/About';
import Price from './Component/Price';
import Contact from './Component/Contact';
import Home from './Component/Home';
function App() {
  return (
    <div >
     <Home />
     <Service />
     <About/>
     <Price />
     <Contact />
    </div>
  );
}

export default App;
